var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon',{staticClass:"icon",class:[_vm.iconNameClass],attrs:{"icon":_vm.name,"fill":_vm.color,"width":_vm.width,"height":_vm.height},on:{"click":_vm.clicked}})}
var staticRenderFns = []

export { render, staticRenderFns }